import { createAction } from "@reduxjs/toolkit";

export const SET_VIEW_STATE = createAction<Number>(
    "CreateAccount/SetViewState"
)
export const CREATE_NEW_ACCOUNT = createAction("CREATE_NEW_ACCOUNT");
export const CREATE_ACCOUNT_FAILED = createAction("CREATE_ACCOUNT_FAILED");
export const CREATE_ACCOUNT_FULFILLED = createAction("CREATE_ACCOUNT_FULFILLED");
export const CREATE_ACCOUNT_CANCELLED = createAction("CREATE_ACCOUNT_CANCELLED");
